import { useToast } from '@chakra-ui/react';

export const useAlert = () => {
  const toast = useToast({
    position: 'top',
    styleConfig: {
      'font-weight': 'regular'
    }
  });

  return {
    info: (message: string) => toast({
      title: message,
      status: 'info',
      isClosable: true,
    }),
    error: (message: string) => toast({
      title: 'Ошибка',
      description: message,
      status: 'error',
      isClosable: true,
    }),
    success: (message: string) => toast({
      title: 'Успешно',
      description: message,
      status: 'success',
      isClosable: true,
    }),
    warning: (message: string) => toast({
      title: 'Внимание!',
      description: message,
      status: 'warning',
      isClosable: true,
    }),
    promise: (promise: Promise<any>, wait: string, error: string, success: string, ) => toast.promise(promise, {
      loading: { title: wait },
      success: { title: success },
      error: { title: 'Ошибка', description: error }
    }),
  };
};
